<script>
import { computed } from 'vue';
import { beforeAfterProps, compareProps } from './prop-definitions.js';
import taggingMixin from '../../lib/tagging/mixin';

const props = {
  ...beforeAfterProps,
  ...compareProps,
};

export default {
  name: 'refapp-beforeafter-provider',
  mixins: [taggingMixin],
  provide() {
    return Object.keys(props).reduce((acc, curr) => {
      acc[curr] = computed(() => this[curr]);
      return acc;
    }, {});
  },
  props,
  render() {
    const isVue3Slot = this.$slots.default instanceof Function;

    if (isVue3Slot) {
      return this.$slots.default();
    }

    return this.$slots.default;
  },
};
</script>
